var __jsx = React.createElement;
import React, { useEffect, useRef } from 'react';
import IconModalClose from "../../assets/images/modal-close.svg";
import { useBreakpoint } from "../../hooks";
import { StyledFullPageModal, StyledFullPageModalContent } from "./styled";

var FullPageModal = _ref => {
  var visible = _ref.visible,
      children = _ref.children,
      onClose = _ref.onClose,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$replace = _ref.replace,
      replace = _ref$replace === void 0 ? false : _ref$replace,
      _ref$showClose = _ref.showClose,
      showClose = _ref$showClose === void 0 ? true : _ref$showClose,
      _ref$hideBeacon = _ref.hideBeacon,
      hideBeacon = _ref$hideBeacon === void 0 ? true : _ref$hideBeacon;
  var containerRef = useRef();
  var closeRef = useRef();

  var _useBreakpoint = useBreakpoint(),
      isMobile = _useBreakpoint.isMobile;

  var handleCloseModal = event => {
    var target = event.target;
    var isCloseIconOrModal = target === closeRef.current || target === containerRef.current;
    if (!isCloseIconOrModal) return;
    onClose && onClose(event);
  };

  var setBeaconVisible = visible => {
    if (!isMobile) return;
    var beacon = document.getElementById('beacon-container');

    if (beacon) {
      beacon.style.display = visible ? 'block' : 'none';
    }
  };

  useEffect(() => {
    if (hideBeacon) {
      setBeaconVisible(!visible);
    }

    return () => {
      setBeaconVisible(true);
    };
  }, [visible]);
  if (!visible) return null;

  if (replace) {
    return __jsx(StyledFullPageModal, {
      ref: containerRef
    }, children);
  }

  return __jsx(StyledFullPageModal, {
    ref: containerRef
  }, __jsx(StyledFullPageModalContent, {
    className: className
  }, showClose && __jsx("img", {
    ref: closeRef,
    className: "modal-close",
    src: IconModalClose,
    onClick: handleCloseModal
  }), children));
};

export default FullPageModal;